import { useTranslation } from 'react-i18next'

import { Alert, ComboBox } from '@reveni-io/reveni-ui'

import { issueRefundAtStatusValues } from '@/common/constants'

import { getOptionsByAvailableStatuses } from './helpers'

const IssueRefundAtStatusSelector = ({ value, onChange, availableStatuses, disabled }) => {
  const { t } = useTranslation()
  const options = getOptionsByAvailableStatuses(availableStatuses)

  return (
    <div>
      <ComboBox
        fullWidth
        label={t('Emisión del reembolso')}
        handleChange={e => onChange(e.target.value)}
        menuItems={options?.map(o => ({ label: t(o.label), value: o.value }))}
        value={value}
        disabled={disabled}
      />
      {value === issueRefundAtStatusValues.shipped && (
        <Alert type="warning">
          {t('Requiere integración con un servicio de logística con actualización de estado en tiempo real')}
        </Alert>
      )}
    </div>
  )
}

export default IssueRefundAtStatusSelector
